import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IRolesAndTreeResponse, IRolesNamespaces } from '../types';
import { ROLES_AND_TREE_API_URL, ROLES_AND_TREE_QUERY, ROLES_PERMISSIONS } from '../constants';

export default function useRolesAndTreeQuery(
  namespace: Ref<IRolesNamespaces | undefined>,
): IContextQueryResult<IRolesAndTreeResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [ROLES_AND_TREE_QUERY, namespace],
    queryFn: ({ signal }) => fetchGet<IRolesAndTreeResponse>(ROLES_AND_TREE_API_URL, {
      signal,
      queryParams: { namespace: namespace.value || '' },
      permission: ROLES_PERMISSIONS.ROLES_CREATE,
    }),
    enabled: computed(() => !!namespace.value),
  });
}
